(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[23728],{

/***/ 433329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ BuildPcModalContent; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(912841);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(573194);
/* harmony import */ var _BuildPcItem_BuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(123579);
/* harmony import */ var _Common_NoProductsFound_NoProductsFound_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(980424);
/* harmony import */ var _Common_Loading_Loading_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(519209);







const StyledBuildPcItem = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_BuildPcItem_BuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BuildPcItem */ .y)`
  border-radius: unset;
  padding: 0.625rem 1rem;
  &:hover {
    box-shadow: unset;
  }
`;
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  height: ${(props) => props.height + "rem"};
  overflow-y: scroll;
  overflow-x: hidden;
  border-bottom: 1px dashed #ddd;
  border-top: 1px dashed #ddd;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledDivider = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i)`
  width: 95%;
  margin: auto;
`;
const StyledNoProductsFound = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_NoProductsFound_NoProductsFound_es_js__WEBPACK_IMPORTED_MODULE_4__/* .NoProductsFound */ .H)`
  margin-top: 5rem;
`;
const BuildPcModalContent = ({
  products = [],
  isLoading,
  onClick
}) => {
  const windowSize = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .useWindowSize */ .i)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_Loading_Loading_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Loading */ .g, {
    top: 150,
    isLoading: !!isLoading
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: ((windowSize == null ? void 0 : windowSize.width) || 0) > 1600 ? 34.08 : 22.725
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNoProductsFound, {
    show: !isLoading && !products.length
  }), products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: product.sku
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBuildPcItem, {
    onClick: () => onClick(product.sku),
    key: product.sku,
    product,
    actionText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Ch\u1ECDn")
  }), index < products.length - 1 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDivider, null)))));
};




/***/ }),

/***/ 14956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BuildPcModalHeader; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(589561);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(918358);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(650983);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23212);
/* harmony import */ var _Common_JDDropdown_JDDropdown_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(786273);
/* harmony import */ var _Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(217622);
/* harmony import */ var _Listing_Filter_components_ActivatedFilters_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(743405);








const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  background: #fff;
`;
const Filter = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isMobile }) => `
  ${isMobile ? `overflow-y: hidden;
      display: flex;
      gap: 5px;
      margin-bottom: 8px
      ` : `
    padding: 0 1rem 0.5rem 1rem;
      display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr 1fr;
  height: 84px;`}
`);
const StyledMiniDropdown = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_JDDropdown_JDDropdown_es_js__WEBPACK_IMPORTED_MODULE_2__/* .JDDropdown */ .F)`
  .dropdown-content {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  ${({ isMobile }) => isMobile ? `.dropdown-button {
    width: max-content;
  }` : ""}
`;
const Sort = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isMobile }) => `
  ${isMobile ? "" : "padding: 0.5rem 1rem;"}
  display: flex;
  justify-content: space-between;
  align-items: center;
`);
const SortTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-weight: 500;
  margin-right: 0.5rem;
`;
const StyledOption = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SelectOption */ .$)`
  padding: 0.365rem 0.75rem;
  cursor: pointer;
  color: ${(props) => props.isActive ? "#1435c3" : ""};
  &:hover {
    background: #f3f3f3;
  }
`;
const OptionName = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Search = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I)(({ isMobile }) => `
  ${isMobile ? `` : `margin-left: 2rem;`}
  flex: 1;
  border-radius: ${isMobile ? "4px" : "999px"};
`);
const StyledTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 20px;
  font-weight: 600px;
  line-height: 24px;
  margin-bottom: 8px;
`;
const BuildPcModalHeader = ({
  filters = [],
  onClickFilter,
  onClickSort,
  activeValues = [],
  searchParams,
  isMobile = false
}) => {
  const onKeyUp = (e) => {
    const keyword = e.target.value;
    if (e.keyCode === 13) {
      onClickFilter && onClickFilter("keyword", keyword || "");
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, !isMobile ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t, {
    content: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Listing_Filter_components_ActivatedFilters_es_js__WEBPACK_IMPORTED_MODULE_6__/* .ActivatedFilters */ .x, {
      onClick: (value) => onClickFilter && onClickFilter(value.filterCode, value.optionCode),
      activeValues
    }),
    title: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\u1ED9 l\u1ECDc")
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\u1ED9 l\u1ECDc")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Filter, {
    isMobile
  }, filters.map((filter, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledMiniDropdown, {
      count: activeValues.filter((value) => value.filterCode === filter.code).length,
      key: index,
      text: filter.name,
      isMobile
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, filter.options.map((value, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
      key: index2,
      link: true,
      variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === value.optionCode) !== -1 ? "primary" : "normal",
      onClick: () => onClickFilter && onClickFilter(filter.code, value.optionCode)
    }, value.optionName))));
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sort, {
    style: isMobile ? {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      gap: 8,
      marginBottom: "8px"
    } : void 0,
    isMobile
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SortTitle, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("S\u1EAFp x\u1EBFp theo")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      gap: isMobile ? 5 : 8
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "quantity.last_3_month",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("quantity.last_3_month", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("B\xE1n ch\u1EA1y"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.ASC */ .d.ASC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.ASC */ .d.ASC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Gi\xE1 t\u0103ng d\u1EA7n"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", _types_es_js__WEBPACK_IMPORTED_MODULE_9__/* .OrderBy.DESC */ .d.DESC)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptionName, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Gi\xE1 gi\u1EA3m d\u1EA7n")))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Search, {
    onKeyUp,
    placeholder: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("T\xECm linh ki\u1EC7n"),
    isMobile
  })));
};




/***/ }),

/***/ 327601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ PrintBuildPc; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(526439);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(587021);
/* harmony import */ var _PrintBuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(523691);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: none;
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 99999;
    width: 100%;
    height: 100%;
  }
`;
const Header = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  text-align: center;
  background: #ebecee;
  width: 100%;
`;
const Logo = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div``;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  width: 100%;
`;
const Footer = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  width: 100%;
  text-align: center;
`;
const Total = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 1.5rem;
  color: #d10000;
  font-weight: 500;
`;
const PrintBuildPc = ({
  total,
  buildpc,
  logoProps
}) => {
  if (!Object.keys(buildpc).length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Logo, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadValues({
    src: "https://phongvu.vn/phongvu/logo-full.svg",
    height: 80,
    lazy: false
  }, logoProps)))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, Object.keys(buildpc).map((key) => {
    const product = buildpc[key].product;
    const quantity = buildpc[key].quantity;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PrintBuildPcItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PrintBuildPcItem */ .p, {
      quantity,
      key,
      product
    });
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Total, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("T\u1ED5ng chi ph\xED:"), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
    value: total
  }))));
};




/***/ }),

/***/ 523691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ PrintBuildPcItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(995667);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(865237);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(587021);
/* harmony import */ var _Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73586);
/* harmony import */ var _Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(770024);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PrintBuildPcItem = ({
  product,
  quantity
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 1.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
    width: 50,
    height: 50,
    src: product.imageUrl,
    objectFit: "contain",
    lazy: false
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 7.5
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_ProductName_ProductName_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductName */ .r, {
    name: product.name
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, null, "x", quantity), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
    col: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ProductPrice */ .j, __spreadValues({}, {
    price: ((_a = product == null ? void 0 : product.price) == null ? void 0 : _a.latestPrice) || 0,
    discount: ((_b = product == null ? void 0 : product.price) == null ? void 0 : _b.discountPercent) || "",
    listedPrice: ((_c = product == null ? void 0 : product.price) == null ? void 0 : _c.supplierRetailPrice) || 0
  }))));
};




/***/ }),

/***/ 786273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ JDDropdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  position: relative;
  padding: 0 1rem;
  text-align: center;
  height: ${props.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: content-box;
  border: 1px solid  var(--button-background-color, ${props.isOpen || props.count ? props.theme.brand.primary : props.theme.colors.gray300});
  color: ${props.count ? props.theme.brand.primary : ""};
  cursor: pointer;
  border-radius: 4px;
 
  ${props.isOpen && `
    z-index: 10;
    border-bottom: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
  `);
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: inline-block;
`;
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1;
  overflow: hidden;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: relative;
  top: 1px;
  left: 2px;
`;
const DropdownContent = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid ${props.theme.brand.primary};
  position: absolute;
  left: 0;
  right: 0;
  margin-top: -1px;
  z-index: 5;
  background: #fff;
`);
const Badge = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span(({ theme }) => `
    font-size: 0.625rem;
    background: ${theme == null ? void 0 : theme.brand.primary};
    border-radius: 50%;
    width: 16px;
    line-height: 16px;
    color: #fff;
    height: 16px;
    text-align: center;
    margin: 0 5px;
  `);
const JDDropdown = (_a) => {
  var _b = _a, {
    text,
    children,
    height = 34,
    count = 0
  } = _b, props = __objRest(_b, [
    "text",
    "children",
    "height",
    "count"
  ]);
  const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [endDelay, setEndDelay] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (dropdownOpen) {
      setTimeout(() => {
        setEndDelay(true);
      }, 200);
    } else {
      setEndDelay(false);
    }
  }, [dropdownOpen, endDelay]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onMouseEnter: () => setDropdownOpen(true),
    onMouseLeave: () => setDropdownOpen(false)
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Button, {
    className: "dropdown-button",
    isOpen: dropdownOpen && endDelay,
    height,
    count
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text), count > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Badge, null, count), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: dropdownOpen && endDelay ? "chevron-up" : "chevron-down",
    size: 12
  })), dropdownOpen && endDelay && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContent, {
    className: "dropdown-content",
    isOpen: dropdownOpen,
    height,
    onClick: () => setDropdownOpen(false)
  }, children));
};




/***/ }),

/***/ 519209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55257);
/* harmony import */ var _LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(465385);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledOverLay = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .a)`
  background: rgba(0, 0, 0, 0.03);
`;
const Loading = (_a) => {
  var _b = _a, {
    isLoading,
    children,
    logo
  } = _b, props = __objRest(_b, [
    "isLoading",
    "children",
    "logo"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledOverLay, __spreadProps(__spreadValues({}, props), {
    show: isLoading
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_3__/* .LogoLoading */ .h, {
    logo
  })), children);
};




/***/ }),

/***/ 980424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ NoProductsFound; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179185);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _assets_images_no_products_found_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76441);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(334751);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 8rem;
  text-align: center;
`;
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 1.5rem;
  font-size: 1rem;
`;
const NoProductsFound = (_a) => {
  var _b = _a, {
    text = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_2__.t)("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o"),
    show
  } = _b, props = __objRest(_b, [
    "text",
    "show"
  ]);
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    width: 200,
    height: 200,
    contain: true,
    src: _assets_images_no_products_found_es_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text));
};




/***/ }),

/***/ 743405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ActivatedFilters; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(969061);



const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)(({ theme }) => `
    margin-left: 0.25rem;
    --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledChip = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Chip */ .A)(({ theme }) => `
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  background: ${theme == null ? void 0 : theme.brand.tertiary} !important;
  color: ${theme == null ? void 0 : theme.brand.primary};
  border: 1px solid  ${theme == null ? void 0 : theme.brand.primary};
`);
const ActivatedFilters = ({
  activeValues,
  onClick
}) => {
  if (!activeValues.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, activeValues.map((option) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledChip, {
    onClick: () => onClick && onClick(option),
    key: option.optionCode
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, option.optionName), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "close",
    size: 10
  }))));
};




/***/ }),

/***/ 76441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ notFoundImage; }
/* harmony export */ });
var notFoundImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";




/***/ }),

/***/ 432283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ DetailNavBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDetailNavBar = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  &.detail {
    box-shadow: none;
  }
`;
const Left = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
`;
const DetailNavBar = (_a) => {
  var _b = _a, {
    right,
    goBack
  } = _b, props = __objRest(_b, [
    "right",
    "goBack"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDetailNavBar, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right));
};




/***/ }),

/***/ 969061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 29px;
  height: 30px;
  border-radius: 999px;
  width: fit-content;
  text-align: center;
  background: #f6f6f6;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  outline: 0;
  white-space: nowrap;
  border: none;
  padding: 0 12px;
  cursor: pointer;
`;
const Chip = (_a) => {
  var _b = _a, {
    onClick,
    children
  } = _b, props = __objRest(_b, [
    "onClick",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    onClick
  }), children);
};




/***/ }),

/***/ 918358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(865237);
/* harmony import */ var _atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64201);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: ${props.hasDivider ? `1px solid ${props.color}` : ""};
`);
const Title = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`);
const Decor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  left: 0;
  margin-top: 2px;
  width: 3px;
  height: 21px;
  background-color:  ${props.color};
`);
const ActionLink = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color} !important;
  --button-icon-color: ${props.color};
  text-decoration: none;
  float: right;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    ${props.hover === "underline" ? "text-decoration: underline" : `color: ${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.brand.primary */ .r.brand.primary} !important`}
  }
`);
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)`
  position: relative;
  top: 2px;
`;
const ActionLinkTitle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  margin-right: 5px;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    actionLink,
    color = "#333",
    hasDivider = false,
    content
  } = _b, props = __objRest(_b, [
    "title",
    "actionLink",
    "color",
    "hasDivider",
    "content"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    hasDivider,
    color
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, null, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Decor, {
    color
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    color,
    className: "title"
  }, title))), content && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
    col: actionLink ? 9.8 : 10.95
  }, content), actionLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, actionLink.regionName && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: actionLink.regionName,
    contentName: actionLink.contentName,
    target: actionLink.target
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, {
    targetPath: actionLink.href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLink, {
    color: actionLink.color || "#f1f0f1",
    hover: actionLink.hover
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLinkTitle, null, actionLink.title), !actionLink.hideIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "chevron-forward",
    size: 13
  })))));
};




/***/ }),

/***/ 573194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72325);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46183);




function useWindowSize() {
  function getSize() {
    if (typeof window !== "undefined")
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
  }
  const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize);
  const updateWindowSize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(setWindowSize, 1e3);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
      return;
    }
    function handleResize() {
      updateWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseDOM */ .Nq) {
    return void 0;
  }
  return windowSize;
}




/***/ }),

/***/ 72325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ })

}]);